import React, { useEffect, useState } from "react";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import useBanner from "../../../../services/Inventory/useBanner";
import { Eye, Trash } from "lucide-react";
import NoIndex from "../../../../components/NoIndex";
import { ToastContainer } from "react-toastify";

function BannerLibrary() {
const { fetchBanner, updateBannerStatus, deleteBanner } = useBanner();

  const [fetchedBanner, setFetchedBanner] = useState([]);
  const [previewHTML, setPreviewHTML] = useState("");
  const [showModal, setShowModal] = useState(false);
const [deleteModal, setDeleteModal] = useState({
  show: false,
  item: null,
});

  const ITEMS_PER_PAGE = 8;
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentItems = fetchedBanner.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  const totalPages = Math.ceil(fetchedBanner.length / ITEMS_PER_PAGE);

  const openPreview = (html) => {
    setPreviewHTML(html);
    setShowModal(true);
  };

  const closePreview = () => {
    setShowModal(false);
    setPreviewHTML("");
  };

 const handleConfirmDelete = async () => {
  const id = deleteModal?.item?.id;

  if (!id) return;

  await deleteBanner(id, () => {
    fetchBanner(setFetchedBanner);
  });

  setDeleteModal({
    show: false,
    item: null,
  });
};

const handleToggleStatus = async (item) => {
  const currentStatus = item?.card_status;
  const newStatus = currentStatus === "Y" ? "N" : "Y";

  setFetchedBanner((prev) =>
    prev.map((b) =>
      b.id === item.id ? { ...b, card_status: newStatus } : b
    )
  );

  try {
    await updateBannerStatus(item, newStatus);

    setTimeout(() => {
      fetchBanner(setFetchedBanner);
    }, 500);
  } catch (error) {
    setFetchedBanner((prev) =>
      prev.map((b) =>
        b.id === item.id ? { ...b, card_status: currentStatus } : b
      )
    );
  }
};

  useEffect(() => {
    fetchBanner(setFetchedBanner);
  }, []);

  return (
    <>
    <NoIndex/>
    <ToastContainer/>
    
    <div className="w-full p-5">

      {/*  HEADER ADDED */}
      <div className="flex justify-between items-center mt-2 mb-5 p-2">
        <h3 className="text-lg font-medium">Banner Library</h3>

        <div className="flex gap-2">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
            className="w-8 h-8 flex items-center justify-center border rounded"
          >
            <SlArrowLeft />
          </button>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
            className="w-8 h-8 flex items-center justify-center border rounded"
          >
            <SlArrowRight />
          </button>
        </div>
      </div>

      {/* GRID */}
      <div className="grid grid-cols-4 gap-4 montserrat-font-1">
        {currentItems.map((item) => (
          <div
            key={item.id}
            className="border rounded-lg p-3 bg-white shadow-sm montserrat-font-1"
          >
            {/* Title + Toggle */}
            <div className="flex justify-between items-center mb-2 montserrat-font-1">
              <h4>{item?.card_title || "NO NAME"}</h4>

              <input
  type="checkbox"
  checked={item?.card_status === "Y"}
  onChange={() => handleToggleStatus(item)}
/>
            </div>

            {/* Preview */}
            <div
              className="h-[120px] bg-gray-100 cursor-pointer overflow-hidden montserrat-font-1"
              onClick={() => openPreview(item?.card_htmlcode)}
            >
              <iframe
                title="preview"
                className="w-full h-full border-none"
                srcDoc={item?.card_htmlcode || ""}
              />
            </div>

            {/* Footer */}
            <div className="flex justify-between mt-3 montserrat-font-1">
              <button
                onClick={() => openPreview(item?.card_htmlcode)}
                className="p-2 rounded hover:bg-gray-100 montserrat-font-1"
              >
                <Eye size={18} />
              </button>

             <button
  onClick={() =>
    setDeleteModal({
      show: true,
      item,
    })
  }
  className="text-red-500 montserrat-font-1 hover:bg-red-50 p-2 rounded"
>
  <Trash size={18} />
</button>

              <button className="text-green-600 border px-3 py-1 rounded-full">
                Set Default
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* PAGINATION (optional keep/remove) */}
      <div className="flex justify-center items-center gap-3 mt-6 montserrat-font-1">
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="px-4 py-1.5 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
  >
    Prev
  </button>

  <span className="text-sm font-medium">
    Page {currentPage} of {totalPages || 1}
  </span>

  <button
    disabled={currentPage === totalPages || totalPages === 0}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="px-4 py-1.5 border rounded disabled:opacity-50 disabled:cursor-not-allowed"
  >
    Next
  </button>
</div>

      {/* Preview MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center montserrat-font-1">
          <div className="bg-white p-4 w-[80%] rounded">
            <div className="flex justify-between mb-3">
              <h5>Banner Preview</h5>
              <button onClick={closePreview}>✕</button>
            </div>

            <div
              style={{ height: "70vh", overflow: "auto" }}
              dangerouslySetInnerHTML={{ __html: previewHTML }}
            />
          </div>
        </div>
      )}

      {/* delete Model */}

      {deleteModal.show && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
    <div className="bg-white w-[360px] rounded-xl shadow-xl p-5">
      <h3 className="text-lg font-semibold text-gray-800 mb-2">
        Delete Banner
      </h3>

      <p className="text-sm text-gray-500 mb-5">
        Are you sure you want to delete{" "}
        <span className="font-semibold text-gray-700">
          {deleteModal.item?.card_title || "this banner"}
        </span>
        ?
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() =>
            setDeleteModal({
              show: false,
              item: null,
            })
          }
          className="px-4 py-2 text-sm rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700"
        >
          Cancel
        </button>

        <button
          onClick={handleConfirmDelete}
          className="px-4 py-2 text-sm rounded-lg bg-red-500 hover:bg-red-600 text-white"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
)}

    </div>
    </>
  );
}

export default BannerLibrary;
